import React from 'react';
import { CircleCheckIcon, CircleXIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/content';
export function Difference() {
  return <section className="w-full bg-stone-50 px-5 py-20 sm:py-28" data-id="element-47" data-mp="a5t49fsozck">
      <div className="mx-auto max-w-5xl" data-id="element-48" data-mp="9vzmbvjka24">
        <div className="mx-auto max-w-3xl text-center" data-id="element-49" data-mp="58z2bpo1u46x">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-red-600" data-id="element-50" data-mp="57ecuegldbfx">
            La Diferencia INGLÉS LISTO™
          </span>
          <h2 className="mt-5 font-serif text-[2rem] font-black leading-[1.08] tracking-tight text-stone-900 sm:text-5xl" data-id="element-51" data-mp="3rgyrl5j7ekde">
            De un Docente Abrumado a un Docente que{' '}
            <span className="italic text-red-600" data-id="element-52" data-mp="3ifr0p8j0oltc">Tiene Todo Listo.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-stone-600 sm:text-base" data-id="element-53" data-mp="3ihlnksdumo02">
            Dale a tus clases una progresión clara, a tus alumnos más confianza
            con el inglés y a ti mismo el tiempo para volver a disfrutar de
            enseñar.
          </p>
        </div>

        <dl className="mx-auto mt-11 grid max-w-3xl grid-cols-1 overflow-hidden rounded-xl border border-stone-200 bg-white sm:grid-cols-3" data-id="element-54" data-mp="1f9k0vyellkqo">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`px-6 py-7 text-center ${index > 0 ? 'border-t border-stone-200 sm:border-l sm:border-t-0' : ''}`} data-id="element-55" data-mp="1t2tbu3i72ebb" data-mpi={index}>
              <dt className="sr-only" data-id="element-56" data-mp="wc10tka4bcge">{stat.label}</dt>
              <dd data-id="element-57" data-mp="1aa7h5mj0wtsb">
                <span className="block font-serif text-3xl font-black text-red-600" data-id="element-58" data-mp="1aaqz338obi6c">
                  {stat.value}
                </span>
                <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.14em] text-stone-500" data-id="element-59" data-mp="15a2xjnmtjixv">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <div className="mt-14 overflow-hidden rounded-3xl bg-white shadow-xl" data-id="element-60" data-mp="2or9121ltbblw">
          <div className="grid md:grid-cols-2" data-id="element-61" data-mp="2otbp4g3emunz">
            <div className="relative bg-stone-100 p-8 sm:p-10" data-id="element-62" data-mp="2ss2pcw362sfb">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white text-stone-400" data-id="element-63" data-mp="2suowwvq257xj">
                <CircleXIcon className="h-5 w-5" aria-hidden="true" data-id="element-64" data-mp="32pyy5h8mtba9" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-stone-500" data-id="element-65" data-mp="2541910zqy7pc">
                El costo de improvisar
              </span>
              <h3 className="mt-3 font-serif text-2xl font-bold tracking-wide text-stone-900" data-id="element-66" data-mp="2a00417fkynyq">
                ANTES
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-stone-500" data-id="element-67" data-mp="2jso1m4edwvyi">
                Lo que preparar cada clase desde cero te quita silenciosamente
                cada semana.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-68" data-mp="1rb38l08g5pex">
                {beforeItems.map(item => <li key={item} className="flex items-center gap-3 rounded-xl bg-white/70 px-4 py-3 text-sm text-stone-600" data-id="element-69" data-mp="1jslv6ixg9qgo">
                    <CircleXIcon className="h-4 w-4 shrink-0 text-stone-400" aria-hidden="true" data-id="element-70" data-mp="19twfmwt10i3l" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="relative bg-white p-8 sm:p-10" data-id="element-71" data-mp="10vkq6y3wbqcq">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-red-600 text-white" data-id="element-72" data-mp="w1q6huoajbdn">
                <CircleCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-73" data-mp="r1k8zxvcaunn" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-red-600" data-id="element-74" data-mp="m2h6ol6qv2jd">
                El sistema INGLÉS LISTO™
              </span>
              <h3 className="mt-3 font-serif text-2xl font-bold tracking-wide text-stone-900" data-id="element-75" data-mp="d4yft06f5tzk">
                CON INGLÉS LISTO™
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-stone-500" data-id="element-76" data-mp="11wvzai8emgjk">
                Entra a cada clase con una estructura clara y materiales
                preparados.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-77" data-mp="t0exi5lxjv0h">
                {afterItems.map(item => <li key={item} className="flex items-center gap-3 rounded-xl bg-red-50 px-4 py-3 text-sm font-medium text-stone-900" data-id="element-78" data-mp="x1qityxrtu2v">
                    <CircleCheckIcon className="h-4 w-4 shrink-0 text-red-600" aria-hidden="true" data-id="element-79" data-mp="o1222wgztfma" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
          <p className="border-t border-stone-100 bg-stone-50 px-6 py-4 text-center text-xs text-stone-500" data-id="element-80" data-mp="24hwi5mrtk3x5">
            Un sistema completo para planificar menos y enseñar con más
            propósito.
          </p>
        </div>
      </div>
    </section>;
}